import { RootState } from '../store'

const selectCounty = (state: RootState) => state.county.selectedCounty;

export const CountySelector = {
  selectCounty
}
